import DriverModal from './DriverModal';

export default DriverModal;



// WEBPACK FOOTER //
// ./src/ondemand/components/DriverModal/index.js